import { com } from '@eidu/web'
import Entity = com.eidu.sharedlib.entity.Entity
import SnapshotEntity = com.eidu.sharedlib.entity.publish.SnapshotEntity

const snapshotEntityToEntity = (snapshotEntity: SnapshotEntity): Entity =>
  new Entity(snapshotEntity.entityId, snapshotEntity.typeId, snapshotEntity.valuesByFieldId, snapshotEntity.links)

export default snapshotEntityToEntity
